"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CloseWizardButton = void 0;

var _react = _interopRequireDefault(require("react"));

var _formik = require("formik");

var _context = require("../../context");

var _constants = require("../../constants");

var _utils = require("../../utils");

var _CloseButton = _interopRequireDefault(require("../CloseButton"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var CloseWizardButton = function CloseWizardButton(_ref) {
  var searchType = _ref.searchType,
      setBodyLocked = _ref.setBodyLocked;

  var _useCigarette = (0, _context.useCigarette)(),
      _useCigarette$state = _useCigarette.state,
      steps = _useCigarette$state.steps,
      isWizard = _useCigarette$state.isWizard,
      dispatch = _useCigarette.dispatch;

  var _useFormikContext = (0, _formik.useFormikContext)(),
      resetForm = _useFormikContext.resetForm;

  var hide = !(isWizard && (searchType === _constants.SEARCH_TYPE_NAMES.PACKAGE && (0, _utils.afterDepartureStep)(steps) || searchType === _constants.SEARCH_TYPE_NAMES.HOTEL && (0, _utils.afterDatepickerStep)(steps)));

  var handleClick = function handleClick() {
    dispatch((0, _context.resetSteps)());
    resetForm({
      values: _constants.INITIAL_VALUES_FORMIK
    });
    setBodyLocked === null || setBodyLocked === void 0 ? void 0 : setBodyLocked(false);
  };

  if (hide) return null;
  return /*#__PURE__*/_react["default"].createElement(_CloseButton["default"], {
    onClick: handleClick
  });
};

exports.CloseWizardButton = CloseWizardButton;